import { pushEvent } from '@allianz/tracking';
import { Injectable } from '@angular/core';
import * as shajs from 'sha.js';


export interface TrackArrtibute {
  name: string
  value: string
  type?: string
  mode?: string
}

declare global {
  export interface Window {
    trackifyDebug: any
    trackifyDefines: any
    version: string
  }
}


@Injectable({
  providedIn: 'root'
})
export class TrackService {

  private readonly ATTRIBUTE = 'process.attribute';
  private attributes: TrackArrtibute[] = []
  private errors = []



  constructor() { }

  init() {
    window.trackifyDebug = false
    window.trackifyDefines = {
      'spaData.qbhome.applicationid': 'application.Id',
      'spaData.qbhome.virtualPageName': { forwardTo: 'application.virtualPageName', forwardTrigger: true },
      'spaData.qbhome.previousVirtualPageName': { forwardTo: 'application.previousVirtualPageName', forwardTrigger: true },
      'spaData.qbhome.eventLabel': { forwardTo: 'event.label', forwardTrigger: true },
     // 'spaData.qbhome.process.attribute': { forwardTo: 'process.attributes', forwardTrigger: true },
      'spaData.qbhome.04..product.name': { forwardTo: 'product.name', forwardTrigger: true },
      'spaData.qbhome.04..product.paymentFrequency': { forwardTo: 'product.paymentFrequency', forwardTrigger: true },
      'spaData.qbhome.03..product.paymentFrequency': { forwardTo: 'product.paymentFrequency', forwardTrigger: true },
      'spaData.qbhome.04..product.price': { forwardTo: 'product.price', forwardTrigger: true },
      'spaData...details': { forwardTo:  'user.details', forwardTrigger: true },
      'spaData...navigationLink': { forwardTo:  'helptext.navigationLink', forwardTrigger: true },
      'spaData...navigationButton': { forwardTo:  'helptext.navigationButton', forwardTrigger: true },
      'spaData...user.profileId': { forwardTo:  'user.profileId', forwardTrigger: true },
      'spaData...user.type': { forwardTo:  'user.type', forwardTrigger: true },
      'spaData...user.loginStatus': { forwardTo:  'user.loginStatus', forwardTrigger: true },
      'spaData...user.postCode': { forwardTo:  'user.details.postCode', forwardTrigger: true },
      'spaData...user.mobilePhone': { forwardTo:  'user.details.mobilePhone', forwardTrigger: true },
      'spaData...user.emailAdress': { forwardTo:  'user.details.emailAdress', forwardTrigger: true },
      'spaData.qbhome.category': { forwardTo: 'process.category', forwardTrigger: true },
      'spaData.qbhome.processName': { forwardTo: 'process.processName', forwardTrigger: true },
      'spaData..category':{ forwardTo:'process.category', forwardTrigger: true },
      'spaData..processName':{ forwardTo: 'process.processName', forwardTrigger: true },
      'spaData..stepName':{ forwardTo: 'process.stepName', forwardTrigger: true },
      'spaData..stepNumber':{ forwardTo: 'process.stepNumber', forwardTrigger: true },
      'spaData.qbhome.stepName': { forwardTo: 'process.stepName', forwardTrigger: true },
      'spaData.qbhome.stepNumber': { forwardTo: 'process.stepNumber', forwardTrigger: true },
      'spaData..stepBetweenName':{ forwardTo: 'process.stepBetweenName', forwardTrigger: true },
      'spaData..process.attribute':{ forwardTo: 'process.attributes.processDetails', forwardTrigger: true },
      'spaData...product.name':{ forwardTo: 'product.name', forwardTrigger: true },
      'spaData...product.paymentFrequency':{ forwardTo: 'product.paymentFrequency', forwardTrigger: true },
      'spaData...product.price':{ forwardTo: 'product.price', forwardTrigger: true },
      'spaData...product.policyNumber':{ forwardTo: 'product.policyNumber', forwardTrigger: true },
      'spaData...product.paymentMethod':{ forwardTo: 'product.paymentMethod', forwardTrigger: true },
      'spaData...legalAcceptance.isOnlineApplicationChecked':{ forwardTo: 'user.consent.isElectronicCommunicationChecked', forwardTrigger: true },
      'spaData...legalAcceptance.isTermsAndConditionsChecked':{ forwardTo: 'user.consent.isTermsAndConditionsChecked', forwardTrigger: true },
      'spaData..popup':{ forwardTo: 'page.attributes.popup', forwardTrigger: true },
      'spaData...siteSection':{ forwardTo: 'page.pageInfo.siteSection', forwardTrigger: true },
      'spaData...language':{ forwardTo: 'page.pageInfo.language', forwardTrigger: true },
      'spaData...pageName':{ forwardTo: 'page.pageInfo.pageName', forwardTrigger: true },
      'spaData...error':{ forwardTo: 'page.error', forwardTrigger: true },
      'spaData...faq':{ forwardTo: 'page.attributes.popup.faq', forwardTrigger: true },
      'spaData...text':{ forwardTo: 'page.attributes.popup.text', forwardTrigger: true },

    }

    this.pushEventTracking('product.name', '');
    this.pushEventTracking('product.price', '');
    this.pushEventTracking('product.paymentFrequency', '');
    this.pushEventTracking('product.paymentMethod', '');
    this.pushEventTracking('product.policyNumber', '');
    this.pushEventTracking('user.profileId', '');
    this.pushEventTracking('details', '');
  }

  addAttribute(name, value, control?, fieldName?, type: 'once' | 'multiple' = 'once', mode: 'add' | 'remove' = 'add') {
    if(control){
      this.checkErrors(control, fieldName)
       
     }

    const isAddingNewOnce = type === 'once' && mode === 'add'
    const isRemovingUnknownValue = !value && mode === 'remove'
    if (isAddingNewOnce || isRemovingUnknownValue) {
      const prevAttribute = this.attributes.filter((attribute) => attribute.name === name)
      if (prevAttribute.length) {
        const lastPrevAttribute = prevAttribute[prevAttribute.length - 1]

        if (lastPrevAttribute.mode !== 'remove') {
          this.attributes.push({
            ...lastPrevAttribute,
            mode: 'remove',
          })
        }
      }
    }
    if (!isRemovingUnknownValue) {
      this.attributes.push({
        name,
        value,
        type,
        mode
      })
    }
    pushEvent(this.ATTRIBUTE, this.attributes, true)

  }

  
  checkErrors(control, fieldName){
    let error;
    if(control.errors){
      if(control.errors.required){
        error = fieldName + '-' + 'The field is required'
      }
      else{
        error = fieldName + '-' + 'The field is invalid'
      }
      if(this.errors.map(e => e.name).indexOf(fieldName) === -1){
        this.errors.push({name:fieldName, message:error});
      }
      if(this.errors.length>1){
        this.pushEventTracking('error', 'Form errors')
      }
      else{
        this.pushEventTracking('error', error)
      }
    }
    else{
        let index = this.errors.map(e => e.name).indexOf(fieldName);
        if (index !== -1) {
          this.errors = this.errors.filter(x=> x.name!==fieldName);
          if(this.errors.length===1){
            this.pushEventTracking('error', this.errors[0].message)
          }
          if(this.errors.length===0)
          {
            this.pushEventTracking('error', '')
          }
        }
    }
  }

  cleanData(){
    this.attributes=[];
    this.errors=[];
    pushEvent(this.ATTRIBUTE, "", true);
    this.pushEventTracking('navigationButton', '');
    this.pushEventTracking('text', '');
    this.pushEventTracking('faq', '');
    this.pushEventTracking('error', '');
  }

  pushEventTracking(path, value){
    if(path == 'user.emailAdress' || path == 'user.mobilePhone'){
      let hashedData = shajs('sha256').update(value).digest('hex');
      pushEvent(path,hashedData);
    }
    else{
      pushEvent(path,value);
    }
  }

  addBusinessEvent(name, value){
    this.attributes.push({
      name,
      value
    })
    pushEvent(this.ATTRIBUTE, this.attributes, true)
  }

  addStepsInfo(name, value, bool){
    pushEvent(name, value, bool);
  }

}
